module.exports = __webpack_public_path__ + "img/AR.bf94211b.png";